import { API } from "../store"
import handleCatch from "../lib/catch"
import { openSnackBar } from "./snack-bar"
import {
  deleteShootRoleFromShoots,
  recallShoot,
  updateShootRoleFromShoots,
} from "./shoots"

export const deleteDealMemoItem = (expense_Id, shootRoleId, userId) => {
  return {
    type: "DEAL_MEMO::DELETE_EXPENSE_ITEM",
    expense_Id,
    shootRoleId,
    userId,
  }
}

export const deleteDealMemoItemInitialValues = (
  expense_Id,
  shootRoleId,
  userId
) => {
  return {
    type: "DEAL_MEMO::DELETE_EXPENSE_ITEM_INITIAL_VALUES",
    expense_Id,
    shootRoleId,
    userId,
  }
}

export const deleteShootRole = (shootRoleId, userId) => {
  return {
    type: "DEAL_MEMO::DELETE_SHOOT_ROLE",
    shootRoleId,
    userId,
  }
}

export const updateShootRole = (shootRoleId, data) => {
  return {
    type: "DEAL_MEMO::UPDATE_SHOOTROLE",
    shootRoleId,
    data,
  }
}

export const unattachUserToARole = shootRoleId => {
  return {
    type: "DEAL_MEMO::UNATTACH_USER_ROLE",
    shootRoleId,
  }
}

export const unattachRoleToShoot = shootRoleId => {
  return {
    type: "DEAL_MEMO::UNATTACH_ROLE_SHOOT",
    shootRoleId,
  }
}

export const updateDealMemoItemAppState = updatedData => {
  return {
    type: "DEAL_MEMO::UPDATE_EXPENSE_ITEM",
    data: updatedData,
  }
}
export const updateDealMemoItemAppStateInitialValues = updatedData => {
  return {
    type: "DEAL_MEMO::UPDATE_EXPENSE_ITEM_INITIAL_VALUES",
    data: updatedData,
  }
}

export const updateDealMemoAdditionalItemAppState = updatedData => {
  return {
    type: "UPDATE_DEAL_MEMO_ADDITIONAL_EXPENSE_ITEM",
    data: updatedData,
  }
}
export const updateDealMemoAdditionalItemAppStateIntitialValues = updatedData => {
  return {
    type: "DEAL_MEMO::UPDATE_ADDITIONAL_EXPENSE_ITEM_INITIAL_VALUES",
    data: updatedData,
  }
}

export const addDealMemoItem = expenseData => {
  return {
    type: "DEAL_MEMO::ADD_EXPENSE_ITEM",
    data: expenseData,
  }
}
export const addAdditionalBillApprovalItem = expenseData => {
  return {
    type: "DEAL_MEMO::ADD_ADDITIONAL_EXPENSE_ITEM",
    data: expenseData,
  }
}

export const addAdditionalBillApprovalItemInitialValues = expenseData => {
  return {
    type: "DEAL_MEMO::ADD_ADDITIONAL_EXPENSE_ITEM_INITIAL_VALUES",
    data: expenseData,
  }
}

export const deleteAdditionalBillApprovalItem = expenseData => {
  return {
    type: "DEAL_MEMO::DELETE_ADDITIONAL_EXPENSE_ITEM",
    data: expenseData,
  }
}
export const deleteAdditionalBillApprovalItemIntialValues = expenseData => {
  return {
    type: "DEAL_MEMO::DELETE_ADDITIONAL_EXPENSE_ITEM_INITIAL_VALUES",
    data: expenseData,
  }
}

export const reorderUsersRolesArray = (newUserRoleArray = [], shootRoleId) => {
  return {
    type: "DEAL_MEMO::REORDER_ROLES_USERS_ARRAY",
    data: newUserRoleArray,
    shootRoleId: shootRoleId,
  }
}

export const setUsersRolesArray = (usersRolesArray = []) => {
  return {
    type: "DEAL_MEMO::SET_ROLES_USERS_ARRAY",
    data: usersRolesArray,
  }
}

export const setUsersRolesArrayInitialValues = (
  usersRolesArrayInitialValues = []
) => {
  return {
    type: "DEAL_MEMO::SET_ROLES_USERS_ARRAY_INITIAL_VALUES",
    data: usersRolesArrayInitialValues,
  }
}

export const setGeneralData = (generalData = []) => {
  return {
    type: "DEAL_MEMO::SET_GENERAL_DATA",
    data: generalData,
  }
}

export const updateCrewStatus = (shootRoleId, propToChange, dataToUpdate) => {
  return {
    type: "DEAL_MEMO::UPDATE_CREW_STATUS",
    shootRoleId,
    propToChange,
    dataToUpdate,
  }
}

// update all crew on a given shoot in redux (e.g., resend or send all deal memos on DealMemo admin page)
export const updateBatchCrewStatusSent = (shootId, sendType) => {
  return {
    type: "DEAL_MEMO::UPDATE_BATCH_CREW_STATUS",
    shootId,
    sendType,
  }
}

export const setExpensesTypesList = (expensesTypesList = []) => ({
  type: "DEAL_MEMO::SET_EXPENSES_TYPES",
  data: expensesTypesList,
})

export const setClassesList = (classesList = []) => ({
  type: "DEAL_MEMO::SET_CLASSES_LIST",
  data: classesList,
})

export const updateToggleFlagExpense = newStatus => {
  return {
    type: "DEAL_MEMO::TOGGLE_FLAG_EXPENSE",
    data: newStatus,
  }
}

export const updateBillingStepState = newStep => {
  return {
    type: "DEAL_MEMO::UPDATE_BILLING_STEP_STATE",
    data: newStep,
  }
}

//action to do any necessary updates to the general data
const updateGeneralData = updatedData => {
  return {
    type: "UPDATE_ANY_KEY_IN_GENERAL_DATA",
    payload: {
      ...updatedData,
    },
  }
}

export const updateSentClientInvoiceEstimate = (documentType, recipients) => {
  return {
    type: "DEAL_MEMO::UPDATE_SENT_CLIENT_INVOICE_ESTIMATE",
    documentType,
    recipients,
  }
}

export const updateAcceptClientInvoiceEstimate = data => {
  return {
    type: "DEAL_MEMO::UPDATE_ACCEPTED_CLIENT_INVOICE_ESTIMATE",
    data,
  }
}

export const getDealMemoData = shootId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/billing/shoots/${shootId}/deal-memo`)
        .then(response => response.body)
        .then(response => {
          let { users, roles, ...generalData } = response.data
          dispatch(setGeneralData(generalData))
          dispatch(
            setUsersRolesArray(
              [...response.data.users, ...response.data.roles].sort(
                (a, b) => a.shoot_role - b.shoot_role
              )
            )
          )
          dispatch(
            setUsersRolesArrayInitialValues(
              [...response.data.users, ...response.data.roles].sort(
                (a, b) => a.shoot_role - b.shoot_role
              )
            )
          )

          resolve(response.data)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const getExpensesTypesList = data => {
  let queryParameter = (data && data.queryParameter) || false
  let company_id = (data && data.company_id) || false
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(
        `/billing/shoots/item-types${
          queryParameter ? `?company_id=${company_id}` : ""
        }`
      )
        .then(response => response.body)
        .then(response => {
          //dont pass the role type that was using before when we have main expenses
          dispatch(setExpensesTypesList(response.data))
          resolve(response.data)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const getClassesList = () => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get("/get-gtt-users")
        .then(response => response.body)
        .then(response => {
          dispatch(setClassesList(response.data))
          resolve(response.data)
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const updateItemOnReduxThatWasCreated = (response, createdItem) => {
  return {
    type: "DEAL_MEMO::UPDATE_EXPENSE_ITEM_UUID_TO_RESPONSE_ID",
    payload: { response, createdItem },
  }
}

export const addDealMemoItemInitialValues = (response, createdItem) => {
  return {
    type: "DEAL_MEMO::ADD_EXPENSE_ITEM_INITIAL_VALUES",
    payload: { response, createdItem },
  }
}

export const addAdditionalDealMemoItemInitialValues = (
  response,
  createdItem
) => {
  return {
    type: "DEAL_MEMO::ADD_ADDITIONAL_EXPENSE_ITEM_INITIAL_VALUES",
    payload: { response, createdItem },
  }
}

export const updateAdditionalExpenseOnReduxThatWasCreated = (
  response,
  createdItem
) => {
  return {
    type: "DEAL_MEMO::UPDATE_ADDITIONAL_EXPENSE_ITEM_UUID_TO_RESPONSE_ID",
    payload: { response, createdItem },
  }
}

export const createExpense = createdItem => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/shoots/deal-memo/item`)
          .send(createdItem)
          .then(response => response.body)
          .then(response => {
            dispatch(updateItemOnReduxThatWasCreated(response, createdItem))
            dispatch(addDealMemoItemInitialValues(response, createdItem))
            dispatch(openSnackBar({ message: "Item created successfully" }))
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createAdditionalExpense = createdAdditionalExpense => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/billing/shoots/deal-memo/additional-item`)
          .send(createdAdditionalExpense)
          .then(response => response.body)
          .then(response => {
            dispatch(
              updateAdditionalExpenseOnReduxThatWasCreated(
                response,
                createdAdditionalExpense
              )
            )
            dispatch(
              addAdditionalDealMemoItemInitialValues(
                response,
                createdAdditionalExpense
              )
            )

            dispatch(openSnackBar({ message: "Item created successfully" }))
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
            dispatch(
              openSnackBar({ message: "Expense creation was unsuccessful" })
            )
          })
      }
      call()
    })
    return deferred
  }
}

export const deleteExpense = (expenseId, shootRoleId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/billing/shoots/deal-memo/item/${expenseId}`)
          .then(response => response.body)
          .then(response => {
            dispatch(deleteDealMemoItem(expenseId, shootRoleId))
            dispatch(deleteDealMemoItemInitialValues(expenseId, shootRoleId))
            dispatch(openSnackBar({ message: "Item Deleted" }))
            resolve(response)
          })
          .catch(err => {
            dispatch(openSnackBar({ message: "Error deleting item" }))
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const deleteAdditionalExpense = (additionalExpenseId, shootRoleId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(
          `/billing/shoots/deal-memo/additional-item/${additionalExpenseId}`
        )
          .then(response => response.body)
          .then(response => {
            dispatch(
              deleteAdditionalBillApprovalItem(additionalExpenseId, shootRoleId)
            )
            dispatch(
              deleteAdditionalBillApprovalItemIntialValues(
                additionalExpenseId,
                shootRoleId
              )
            )
            dispatch(openSnackBar({ message: "Item Deleted" }))
            resolve(response)
          })
          .catch(err => {
            dispatch(openSnackBar({ message: "Error deleting item" }))
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const deleteShootRoleCall = (shootRoleId, shootId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.delete(`/billing/shoots/deal-memo/${shootRoleId}`)
          .then(response => response.body)
          .then(response => {
            dispatch(deleteShootRole(shootRoleId))
            dispatch(deleteShootRoleFromShoots(shootId, userId))
            dispatch(recallShoot(true))

            setTimeout(() => {
              dispatch(recallShoot(false))
            }, 800)
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

//update expense item
export const updateExpense = (data, itemId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/item/${itemId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            let updatedData = {
              ...response.updated_data,
              role_id: data.role_id,
              user_id: data.user_id,
              type_name: data.type_name,
            }
            //update app state
            dispatch(updateDealMemoItemAppState(updatedData))
            dispatch(updateDealMemoItemAppStateInitialValues(updatedData))
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
            dispatch(openSnackBar({ message: "Error updating item" }))
          })
      }
      call()
    })
    return deferred
  }
}

//update order item
export const updateItemsOrder = (orderData, newItemsArray, shootRoleId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put("/deal-memo/update-deal-memo-order")
          .send(orderData)
          .then(response => response.body)
          .then(response => {
            dispatch(openSnackBar({ message: "Item(s) have been reordered" }))
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
            dispatch(openSnackBar({ message: "Error ordering item" }))
          })
      }
      call()
    })
    return deferred
  }
}

export const updateAdditionalExpenseOnServerAndApp = (
  data,
  additionalItemId
) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/additional-item/${additionalItemId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            let updatedData = {
              ...data,
              ...response.updated_data,
              shoot_role: data.shoot_role_id,
            }
            //update app state
            dispatch(updateDealMemoAdditionalItemAppState(updatedData))
            dispatch(
              updateDealMemoAdditionalItemAppStateIntitialValues(updatedData)
            )
            dispatch(openSnackBar({ message: "Item updated." }))
            resolve(response)
          })

          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
            dispatch(openSnackBar({ message: "Item update was unsuccessful." }))
          })
      }
      call()
    })
    return deferred
  }
}

export const updateCrewStatusCall = (
  data,
  shootRoleId,
  type,
  shootId,
  userId,
  dataToUpdateDetails
) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/${shootRoleId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            dispatch(updateCrewStatus(shootRoleId, type, data))
            dispatch(
              updateShootRoleFromShoots(shootId, userId, dataToUpdateDetails)
            )
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

// used to send all & resend all crew deal memos
export const updateAllCrewStatus = (shootId, data) => {
  const { sendType } = data
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/status/${shootId}`)
          .send(data)
          .then(response => response.body)
          .then(res => {
            dispatch(updateBatchCrewStatusSent(shootId, sendType))
            resolve(res)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

// flag or unflag expenses (not configured for additionalExpenseId)
export const updateExpenseFlagStatus = (flagData, expenseId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/item-status/${expenseId}`)
          .send(flagData)
          .then(response => response.body)
          .then(() => {
            dispatch(updateToggleFlagExpense({ ...flagData, expenseId }))
            resolve()
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

// an action that can update any KEY and VALUE in the GENERAL_DATA
export const updateGeneralDataProperties = (data, shootId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/general-data/${shootId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            dispatch(updateGeneralData(response.updated_data))
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}
export const updateDealMemoBillingStep = (stepData, shootId) => {
  //stepdata contains direction & desired next billing step number
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/billing-steps/${shootId}/update`)
          .send(stepData)
          .then(response => response.body)
          .then(response => {
            // response.data -> id, step, step_name
            dispatch(updateBillingStepState(response.data))
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .catch(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateDealMemoClientStatus = (data, shootId, action) => {
  const { action_type, email_to, ...rest } = data
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/shoots/deal-memo/${action_type}/${shootId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (action === "sent") {
              dispatch(updateSentClientInvoiceEstimate(action_type, email_to))
            } else {
              dispatch(updateAcceptClientInvoiceEstimate(rest))
            }
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .then(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateCommissionNet = (data, shootRoleId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/commission-net/${shootRoleId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            dispatch(updateShootRole(shootRoleId, data))
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .then(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateUserApprentice = (data, shootRoleId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/billing/apprentice/${shootRoleId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            dispatch(updateShootRole(shootRoleId, data))
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .then(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const markPaymentReceived = (data, invoiceId, updateCall) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/update-client-invoice-status/${invoiceId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (updateCall) {
              dispatch(updateGeneralData(updateCall))
            }
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .then(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const adjustClientPayment = (data, invoiceId, updateCall) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/adjust-client-invoice-payment/${invoiceId}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            if (updateCall) {
              dispatch(updateGeneralData(updateCall))
            }
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .then(reject)
          })
      }
      call()
    })
    return deferred
  }
}

// Manage stripe users

export const getStripeUserUsingId = id => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.get(`/get-user-stripe-data/${id}`)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .then(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const updateStripeUserUsingId = (id, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.put(`/update-user-stripe/${id}`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .then(reject)
          })
      }
      call()
    })
    return deferred
  }
}

export const createStripeUser = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () => {
        API.post(`/create-user-stripe`)
          .send(data)
          .then(response => response.body)
          .then(response => {
            resolve(response)
          })
          .catch(err => {
            handleCatch(err, dispatch)
              .then(call)
              .then(reject)
          })
      }
      call()
    })
    return deferred
  }
}
